<template>
  <v-snackbar
      transition="scale-transition"
      v-model="alertConfig.snackbar.visible"
      :multi-line="alertConfig.snackbar.mode === 'multi-line'"
      :color="computeBgColor"
      :timeout="alertConfig.snackbar.timeout"
      :top="true"
      :right="true" data-qa="dobsnackbar-snackbar-uaozej">
      <div class="alert-container" data-qa="dobsnackbar-div-lv3z3j">
        <div class="alert-icon" data-qa="dobsnackbar-div-8g7zq">
          <v-icon :color="computedIconColor" medium data-qa="dobsnackbar-icon-wqpc31e">{{ getSnackbarIcon() }}</v-icon>
        </div>
        <div class="alert-msg" v-if="alertConfig.snackbar.title" data-qa="dobsnackbar-div-ok7kf">{{ alertConfig.snackbar.title }}
          <div class="alert-small-text" data-qa="dobsnackbar-div-u1anwi">{{ alertConfig.snackbar.text }}</div>
          <template v-if="config.snackbar.reason">
            <li class="alert-small-text" v-for="(item, key) in config.snackbar.reason" style="color:black" :data-qa="`dobsnackbar-li-bj5sbc-${key}`" :key="key">
                {{ item }}
            </li>
          </template>
        </div>
        <div class="alert-msg alert-normal-text" v-if="!alertConfig.snackbar.title" data-qa="dobsnackbar-div-xqhmwl">{{ alertConfig.snackbar.text }}</div>
        <v-btn class="close-btn" icon @click="alertConfig.snackbar.visible = false" data-qa="dobsnackbar-btn-cp6bv">
            <v-icon :color="snackbarClose" size="16" class="material-symbols-outlined" data-qa="dobsnackbar-icon-ctypoa">close</v-icon>
        </v-btn>
      </div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AlertSnackbar',
  props: {
    config: {
      type: Object
    }
  },
  data () {
    return {
      alertConfig: this.config
    }
  },
  computed: {
    computedIconColor () {
      return this.getColorCode()
    },
    computeBgColor () {
      return this.getBgColorCode()
    },
    snackbarClose () {
      return '#000000'
    }
  },
  methods: {
    getColorCode () {
      const colorMapping = {
        error: '#D60040',
        success: '#008744',
        info: '#694ED6',
        warning: '#FF600A'
      }
      const color = colorMapping[this.alertConfig.snackbar.color]
      return color
    },
    getBgColorCode () {
      const bgColorMapping = {
        error: {
          background: '#FDF7F9',
          border: 'hsla(0, 80%, 46%, 0.911)'
        },
        success: {
          background: '#F7FBF9',
          border: 'hsla(138, 87%, 38%, 0.4)'
        },
        info: {
          background: '#FAF9FD',
          border: 'hsla(281, 58%, 70%, 0.4)'
        },
        warning: {
          background: '#FFFCFA',
          border: 'hsla(27, 100%, 50%, 0.4)'
        }
      }
      const color = bgColorMapping[this.alertConfig.snackbar.color]
      document.documentElement.style.setProperty('--snackbar-border-color', color.border)
      return color.background
    },
    getSnackbarIcon () {
      const iconMapping = {
        error: 'mdi-alert-circle',
        success: 'mdi-check-bold',
        info: 'mdi-information-outline',
        warning: 'mdi-alert-outline'
      }
      return iconMapping[this.alertConfig.snackbar.color]
    }
  }
}
</script>

<style scoped>

:root {
  --snackbar-border-color: #000000; /* Default color */
}

.alert-container {
  position: relative;
  display: grid;
  grid-template-columns: 1.5fr 9.5fr 1fr;
  gap: 1px;
  align-items: center;
}

.alert-icon {
  /*  margin-top: -20%; */
  margin: 0 20%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
}

.alert-msg {
  padding-left: 10px;
  font-size: 14px;
  color: #000000;
  line-height: 21px;
  letter-spacing: 1px;
  font-weight: bold;
  text-align: left;
}

.alert-small-text {
  font-size: small;
  font-weight: lighter;
}

.alert-normal-text {
  font-size: small;
  font-weight: 450;
  font-family: Arial, Helvetica, sans-serif;
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -20px;
  color: #000000;
}

::v-deep .v-sheet.v-snack__wrapper {
  border: 1px solid var(--snackbar-border-color) !important;
}

.custom-moveDown-enter-active {
  animation: moveDown 1s;
}

@keyframes moveDown {
  0% {
    top: -10%;
  }
  100% {
     top: 0%;
  }
}
</style>
